import { apiClient } from "../lib/api";

/**
 * Sportsnew service adapter.
 *
 * Crypto keeps one Axios owner (`src/lib/api.js`). Casino Sportsnew services
 * extend this adapter so they retain their response contract without creating
 * a second auth/backoff interceptor stack.
 */
export default class Services {
  constructor(init = {}) {
    this._name = "ROOT";
    this._initializer = init;
    this.controller = new AbortController();
    this.isFetching = false;
    this.axios = (url, config = {}) =>
      apiClient({
        url,
        ...config,
        signal: config.signal || this.controller.signal,
      });
  }

  abort = () => {
    this.controller.abort();
    this.controller = new AbortController();
  };

  decorate = async (request) => {
    let result = { message: "", data: null, error: null, networkError: false };
    this.isFetching = true;
    try {
      let response = await request();
      let { data } = response;
      return { ...result, ...data, httpStatus: response?.status };
    } catch (error) {
      let resp = {};
      if (error?.response) {
        resp = { message: "Error in  response", ...error.response.data, httpStatus: error.response.status };
      } else if (error?.request) {
        resp = {
          message: "인터넷 소켓 연결이 불안정 합니다.",
          ...error.request.data,
          networkError: true,
        };
      } else {
        resp = { message: error?.message || "Request failed", error };
      }
      return { ...result, ...resp };
    } finally {
      this.isFetching = false;
    }
  };
}
